export const ANALYTICS_CLICK_ATTR = 'data-click-param';
export const ANALYTICS_VIEW_ATTR = 'data-view-param';
